import axios from 'axios';

export default axios.create({
  // validateStatus: (status) => status < 500,
  baseURL: 'https://apirest.prod.lasvegasenvivo.com',
  // baseURL: 'http://192.168.1.175:4000',
});
